// Planted defects for the unit's checks, each beside what it breaks (engine/CLAUDE.md). A game's tests switch them on to
// prove a check goes red.

/** Planted defects (each beside what it breaks). */
export const QUEST_JOURNAL_FAULTS = {
  /** The module drops quest changes (never hears `story:quest`, index.ts): "every change reaches the journal" must go
   *  red. */
  deaf: false,
  /** The Active tab lists offered quests whatever `showOffered` says (0.1.0's filter, screen.ts): "Active lists only
   *  accepted quests" must go red. */
  offeredInActive: false,
};
